import { state, mutations } from './state';
import actions from './actions';
import getters from './getters';

export const customerResultsModule = {
  state,
  mutations,
  actions,
  getters
};

export default customerResultsModule;